<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="90px">
            <el-form-item label="所属类型" prop="indexTypeCopy">
                <el-radio-group v-model="searchForm.indexTypeCopy" @input="getOtherList()">
                    <el-radio :label="0">标签</el-radio>
                    <el-radio :label="1">分组</el-radio>
                    <el-radio :label="2">专题</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="索引名称" prop="indexIds">
                <el-select style="width: 100%" v-model="searchForm.indexIds" multiple
                           v-if="searchForm.indexTypeCopy != 1"
                           placeholder="请选择索引名称">
                    <el-option
                            v-for="item in indexNameList"
                            :key="item.id"
                            :disabled="item.indexId ? true : false"
                            :label="item.indexName"
                            :value="item.id">
                    </el-option>
                </el-select>
                <treeSelect ref="menuParentTree" v-if="searchForm.indexTypeCopy == 1"
                            :props="{
                                  children: 'children',
                                  label: 'indexName',
                                  value:'id'
                                 }"
                            :data="indexNameList"
                            :value="searchForm.indexIds"
                            :clearable="true"
                            :showCheckbox="true"
                            :accordion="true"
                            :checkStrictly="true"
                            @getValue="selectCascader"
                ></treeSelect>
            </el-form-item>
            <el-form-item label="排序" prop="indexSort">
                <el-input v-model.trim="searchForm.indexSort" @input="setTndexSort" maxlength="5"
                          placeholder="请输入排序">
                </el-input>
            </el-form-item>
            <el-form-item label="状态" prop="indexState">
                <el-switch
                        v-model="searchForm.indexState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import treeSelect from "@/components/treeSelect/treeSelect.vue";

export default {
    name: "addDivide",
    components: {treeSelect},
    data() {
        var checkIndexTypeCopy = (rule, value, callback) => {
            if (this.searchForm.indexTypeCopy == 1) {
                console.log(value)
                if (value === '') {
                    callback(new Error('请选择所属类型'))
                } else {
                    callback()
                }
            } else {
                if (!value || value.length == 0) {
                    callback(new Error('请选择所属类型'))
                } else {
                    callback()
                }
            }
        }
        return {
            title: '新增分类索引',
            visible: false,
            searchForm: {
                id: '',
                indexTypeCopy: 0,
                indexIds: [],
                indexSort: '',
                indexState: '0',
            },
            rules: {
                indexIds: [
                    {validator: checkIndexTypeCopy, trigger: 'blur'},
                    {required: true, message: '请输入索引名称', trigger: 'blur'}
                ],
                checkIndexTypeCopy: [
                    {required: true, message: '请选择所属类型', trigger: 'change'}
                ],
            },
            indexNameList: [],
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.searchForm = {
                id: '',
                indexIds: '',
                indexSort: '',
                indexTypeCopy: 0,
                indexState: '0',
            }
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
            if (row) {
                this.title = '编辑分类索引'
                this.$axios(this.api.academic.categoricalindexGetById + row.id, {}).then(data => {
                    if (data && data.status) {
                        this.searchForm.id = data.data.id
                        this.searchForm.indexState = data.data.indexState
                        this.searchForm.indexSort = data.data.indexSort + ''
                        this.searchForm.indexTypeCopy = parseInt(data.data.indexType)
                        let indexId
                        if (this.searchForm.indexTypeCopy == 1) {
                            indexId = data.data.indexId
                        } else {
                            indexId = [data.data.indexId]
                        }
                        this.getOtherList(indexId)
                    }
                })
            } else {
                this.title = '新增分类索引'
                this.getOtherList()
            }
        },

        getOtherList(indexId) {
            this.searchForm.indexIds = ''
            this.$axios(this.api.academic.categoricalindexIndexList, {
                type: this.searchForm.indexTypeCopy
            }, 'get').then(data => {
                if (data && data.status) {
                    if (this.searchForm.indexTypeCopy == 1) {
                        let dataList = data.data
                        dataList.forEach(item => {
                            this.$set(item, 'disabled', item.indexId ? true : false)
                        })
                        this.indexNameList = this.handleTree(
                            dataList,
                            'id',
                            'parentId',
                            'children',
                            '0'
                        )
                    } else {
                        this.indexNameList = data.data
                    }
                    this.$nextTick(() => {
                        this.searchForm.indexIds = indexId
                    })
                }
            })
        },

        selectCascader(val) {
            this.searchForm.indexIds = val
        },

        //设置排序
        setTndexSort() {
            this.searchForm.indexSort = this.searchForm.indexSort.replace(/[^0-9]/g, "")
            // if (this.searchForm.indexSort == 0) {
            //     this.searchForm.indexSort = ''
            // }
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.indexTypeCopy == 1) {
                        this.searchForm.indexIds = this.searchForm.indexIds.split(',')
                    }
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.categoricalindexUpdateById, {
                            ...this.searchForm,
                            indexType: this.searchForm.indexTypeCopy,
                        }, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.categoricalindexSave, {
                            ...this.searchForm,
                            indexType: this.searchForm.indexTypeCopy,
                        }, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('提交成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

</style>